<template>
  <!--模版编辑页面-->
  <div class="main">
    <a-card>
      <a-form ref="form" :model="formData1" layout="inline">
        <a-row :gutter="48">
          <a-col :md="9" :sm="12">
            <a-form-item label="模版名称:">
              <a-input v-model="formData1.templatename" style="width: 400px"></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="9" :sm="12">
            <a-form-item label="模版类型:">
              <a-select v-model="formData1.templatetype" placeholder="请选择模板类型" style="width: 400px">
                <a-select-option :value="1">点表</a-select-option>
                <a-select-option :value="2">线表</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col class="mag-tp">
            <span>
              <a-button type="primary" @click="add" v-action:add>新增</a-button>
              <a-button type="primary" style="margin-left: 30px" @click="queryList" >查询</a-button>
              <a-button style="margin-left: 30px" @click="reset" >重置</a-button>
              <a-button type="danger" style="margin-left: 30px" @click="deleteTemplate" v-action:del>删除</a-button>
            </span>
          </a-col>
        </a-row>
        <!--表格数据-->
        <a-table
          size="middle"
          rowKey="id"
          :data-source="tableData"
          :columns="columns"
          bordered
          :pagination="pagination"
          :row-selection="{
            selectedRowKeys: selectedRows,
            onChange: (selectedRowKeys) => {
              this.selectedRows = selectedRowKeys
            },
          }"
          @change="handleTableChange"
        >
          <template slot="action" slot-scope="text, record">
            <a-space>
              <a-button type="primary" ghost size="small" @click="editItem(record)" v-action:edit>编辑</a-button>
              <a-button type="primary" ghost size="small" @click="viewTemplate(record.id)" >查看</a-button>
            </a-space>
          </template>
        </a-table>
      </a-form>
    </a-card>
    <!--新增/编辑弹窗-->
    <a-modal
      :title="isEditMode ? '编辑' : '新增'"
      :visible.sync="addDialogVisible"
      width="25%"
      @ok="submitForm"
      @cancel="handleCancel"
    >
      <a-form ref="form" :model="formData">
        <a-row>
          <a-col :md="18">
            <a-form-item label="模版类型:" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-model="formData.templateType" style="width: 280px" @change="handleTypeChange">
                <a-select-option :value="1">点表</a-select-option>
                <a-select-option :value="2">线表</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :md="18">
            <a-form-item label="模版名称:" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-model="formData.templateName"
                placeholder="请输入模板名称"
                style="width: 280px; margin-bottom: 10px"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>

    <!-- 模板字段编辑弹窗 -->
    <a-modal
      :title="isView ? '查看模板字段' : '编辑模板字段'"
      :visible="templateFieldsVisible"
      width="40%"
      @cancel="handleFieldsCancel"
      :footer="null"
    >
      <div class="template-fields-container">
        <!-- 顶部说明和工具栏 -->
        <div class="template-header">
          <div class="template-info">
            <div class="template-name-row">
              <div class="template-name-container">
                模板名称：
                <template v-if="isView">
                  <span style="font-size: 16px; font-weight: bold">{{ formData.templateName }}</span>
                </template>
                <template v-else>
                  <a-input
                    v-model="formData.templateName"
                    placeholder="请输入模板名称"
                    style="width: 200px; margin-left: 8px"
                  />
                </template>
              </div>
              <div class="template-fields-toolbar" v-if="!isView">
                <a-button type="primary" @click="saveTemplate" v-action:add> <a-icon type="save" />保存模板 </a-button>
                <a-button style="margin-left: 8px" @click="addColumn" v-action:add> <a-icon type="plus" />添加列 </a-button>
                <a-button
                  type="danger"
                  style="margin-left: 8px"
                  @click="deleteSelectedColumns"
                  :disabled="!selectedColumns.length"
                  v-action:del
                >
                  <a-icon type="delete" />删除选中
                </a-button>
              </div>
            </div>
            <p class="template-type">模板类型：{{ formData.templateType === 1 ? '点表' : '线表' }}</p>
          </div>
        </div>

        <!-- 字段列表 -->
        <div class="template-fields-table">
          <div class="fields-list-header" v-if="templateFields.length">
            <span class="col-handle"></span>
            <span class="col-checkbox" v-if="!isView"></span>
            <span class="col-index">序号</span>
            <span class="col-field">字段名称</span>
          </div>
          <draggable
            v-model="templateFields"
            handle=".drag-handle"
            :disabled="isView"
            @end="onDragEnd"
            tag="div"
            class="fields-draggable-list"
            ghost-class="field-row-ghost"
          >
            <div
              v-for="(record, index) in templateFields"
              :key="record.id"
              class="field-row"
              @contextmenu.prevent="!isView && showContextMenu($event, index)"
            >
              <span class="col-handle drag-handle" v-if="!isView">
                <a-icon type="drag" />
              </span>
              <span class="col-checkbox" v-if="!isView">
                <a-checkbox
                  :checked="selectedColumns.includes(record.id)"
                  @change="(e) => onFieldSelectChange(record.id, e.target.checked)"
                />
              </span>
              <span class="col-index">{{ index + 1 }}</span>
              <span class="col-field">
                <template v-if="isView">
                  {{ record.value }}
                </template>
                <a-input
                  v-else
                  v-model="record.value"
                  placeholder="请输入字段名称"
                  style="width: 100%"
                  allow-clear
                />
              </span>
            </div>
          </draggable>
          <a-empty v-if="!templateFields.length" description="暂无字段，请点击添加列" />
        </div>

        <!-- 右键菜单 -->
        <a-menu v-if="contextMenuVisible && !isView && $auth('edit-model.edit')" :style="contextMenuStyle" class="context-menu">
          <a-menu-item key="insertLeft" @click="insertColumn('left')" v-if="$auth('edit-model.add')">
            <a-icon type="vertical-align-top" />头部插入列
          </a-menu-item>
          <a-menu-item key="insertRight" @click="insertColumn('right')" v-if="$auth('edit-model.add')">
            <a-icon type="vertical-align-bottom" />尾部插入列
          </a-menu-item>
          <a-menu-item key="delete" @click="deleteColumn" v-if="$auth('edit-model.delete')"> <a-icon type="delete" />删除当前列 </a-menu-item>
        </a-menu>
      </div>
    </a-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

const columns = [
  {
    title: '序号',
    dataIndex: 'sort',
    align: 'center',
    width: 80,
    customRender: (text, record, index) => index + 1,
  },
  {
    title: '模板名称',
    dataIndex: 'templateName',
    key: 'templateName',
    align: 'center',
  },
  {
    title: '模板类型',
    dataIndex: 'templateType',
    key: 'templateType',
    align: 'center',
    customRender: (text) => (text === 1 ? '点表' : '线表'),
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    key: 'createTime',
    align: 'center',
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    align: 'center',
  },
]

export default {
  name: 'EditModel',
  components: {
    draggable,
  },
  data() {
    return {
      // 分页数据
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
      },
      // 新增弹窗显示与隐藏
      addDialogVisible: false,
      isEditMode: false,
      formData: {
        templateName: '',
        templateType: 1, // 默认为点表
      },
      formData1: {
        templatename: '',
        templatetype: '',
      },
      // 表格数据
      tableData: [],
      columns,
      selectedRows: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },

      // 模板字段相关
      templateFieldsVisible: false,
      templateFields: [],
      selectedColumns: [],
      nextFieldId: 1,
      contextMenuVisible: false,
      contextMenuStyle: {
        position: 'fixed',
        top: '0px',
        left: '0px',
      },
      currentColumnIndex: -1,

      // 模板类型选项
      templateTypeOptions: [
        { label: '点表', value: 1 },
        { label: '线表', value: 2 },
      ],

      // 所有可选的字段值（用于输入建议）
      allFieldValues: [],
      isView: false, // 是否是查看模式
      currentId: null,
    }
  },
  created() {
    this.queryList()
  },
  methods: {
    // 获取模板列表
    async queryList() {
      try {
        const params = {
          page: this.pagination.current,
          limit: this.pagination.pageSize,
          templateName: this.formData1.templatename,
          templateType: this.formData1.templatetype,
        }
        const res = await this.$http.get('/gis-manager/foundation/template/page', { params })
        if (res.code === 0) {
          this.tableData = res.data.list || []
          this.pagination.total = Number(res.data.total) || 0
          // 清空选中行
          this.selectedRows = []
        }
      } catch (error) {
        console.error('获取模板列表失败:', error)
      }
    },

    // 新增模板
    async submitForm() {
      // 表单验证
      if (!this.formData.templateName || !this.formData.templateType) {
        this.$message.warning('请填写完整信息')
        return
      }

      // 关闭新增弹窗
      this.addDialogVisible = false

      // 获取默认模板数据并显示字段编辑弹窗
      await this.getDefaultTemplate(this.formData.templateType)
    },

    // 删除模板
    async deleteTemplate() {
      if (this.selectedRows.length === 0) {
        return this.$message.warning('请选择要删除的记录')
      }

      const _this = this
      this.$confirm({
        title: '确认删除',
        content: '是否确认删除选中的模板？删除后不可恢复！',
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          try {
            const res = await _this.$http.get(`/gis-manager/foundation/template/remove/${_this.selectedRows[0]}`)
            if (res.code === 0) {
              _this.$message.success('删除成功')
              _this.queryList()
            }
          } catch (error) {
            console.error('删除模板失败:', error)
          }
        },
      })
    },

    // 查看模板详情
    async viewTemplate(id) {
      try {
        const res = await this.$http.get(`/gis-manager/foundation/template/get/${id}`)
        if (res.code === 0) {
          this.isView = true
          this.formData = res.data
          // 设置模板字段数据
          this.templateFields =
            res.data.templateFieldsList?.map((field, index) => ({
              id: this.nextFieldId++,
              value: field.value,
              sort: index + 1,
            })) || []
          // 保存所有可选字段
          this.allFieldValues = res.data.templateFieldsList.map((field) => field.value)
          // 显示模板字段弹窗
          this.templateFieldsVisible = true
        }
      } catch (error) {
        console.error('获取模板详情失败:', error)
        this.$message.error('获取模板详情失败')
      }
    },

    // 获取默认模板
    async getDefaultTemplate(type) {
      try {
        const url =
          type === 1
            ? '/gis-manager/foundation/template/get/point/template'
            : '/gis-manager/foundation/template/get/pipe/template'
        const res = await this.$http.get(url)
        if (res.code === 0) {
          // 保存所有可选字段（用于输入建议）
          this.allFieldValues = res.data.map((field) => (typeof field === 'string' ? field : field.value || field))
          this.templateFields = res.data.map((field, index) => ({
            id: this.nextFieldId++,
            value: typeof field === 'string' ? field : field.value || field,
            sort: index + 1,
          }))
          if (!this.addDialogVisible) {
            this.templateFieldsVisible = true
          }
        }
      } catch (error) {
        console.error('获取默认模板失败:', error)
      }
    },

    // 新增弹窗显示与隐藏
    add() {
      this.isEditMode = false
      this.formData = { templateName: '', templateType: 1 }
      this.addDialogVisible = true
    },

    // 编辑
    async editItem(record) {
      try {
        // 先获取模板详情
        const res = await this.$http.get(`/gis-manager/foundation/template/get/${record.id}`)
        if (res.code === 0) {
          this.isView = false
          this.currentId = record.id
          this.formData = res.data

          // 根据模板类型获取可选字段
          const templateTypeUrl =
            res.data.templateType === 1
              ? '/gis-manager/foundation/template/get/point/template'
              : '/gis-manager/foundation/template/get/pipe/template'

          const templateFieldsRes = await this.$http.get(templateTypeUrl)
          if (templateFieldsRes.code === 0) {
            // 保存所有可选字段
            this.allFieldValues = templateFieldsRes.data

            // 设置模板字段数据
            this.templateFields =
              res.data.templateFieldsList?.map((field, index) => ({
                id: this.nextFieldId++,
                value: field.value,
                sort: index + 1,
              })) || []

            // 显示模板字段弹窗
            this.templateFieldsVisible = true
          }
        }
      } catch (error) {
        console.error('获取模板详情失败:', error)
        this.$message.error('获取模板详情失败')
      }
    },

    // 重置
    reset() {
      this.formData1 = {
        templatename: '',
        templatetype: '',
      }
      this.queryList()
    },

    // 选择行变化
    onSelectChange(selectedKeys) {
      this.selectedColumns = selectedKeys
    },
    onFieldSelectChange(id, checked) {
      if (checked) {
        if (!this.selectedColumns.includes(id)) {
          this.selectedColumns.push(id)
        }
      } else {
        this.selectedColumns = this.selectedColumns.filter((sid) => sid !== id)
      }
    },
    onDragEnd() {
      this.templateFields.forEach((field, index) => {
        field.sort = index + 1
      })
    },

    // 类型变化
    handleTypeChange(value) {
      this.getDefaultTemplate(value)
    },

    // 取消
    handleCancel() {
      this.addDialogVisible = false
    },

    // 保存模板
    async saveTemplate() {
      // 查看模式下直接关闭弹窗
      if (this.isView) {
        this.handleFieldsCancel()
        return
      }

      try {
        if (!this.formData.templateName) {
          this.$message.warning('请输入模板名称')
          return
        }

        if (!this.templateFields.length) {
          this.$message.warning('请至少添加一个字段')
          return
        }

        if (this.templateFields.some((field) => !field.value)) {
          this.$message.warning('请填写所有的字段名称')
          return
        }

        const templateData = {
          id: this.currentId,
          templateName: this.formData.templateName,
          templateType: this.formData.templateType,
          templateFieldsList: this.templateFields.map((field) => ({
            value: field.value,
            sort: field.sort,
          })),
        }

        // 根据currentId判断是新增还是更新
        const url = this.currentId ? '/gis-manager/foundation/template/update' : '/gis-manager/foundation/template/add'

        this.$message.loading('正在保存模板...', 0)
        const res = await this.$http.post(url, templateData)
        if (res.code === 0) {
          this.$message.destroy()
          const successMsg = this.currentId ? '更新模板成功' : '新增模板成功'
          // 使用notification替代message，显示更明显
          this.$notification.success({
            message: '操作成功',
            description: successMsg,
            duration: 3
          })
          this.handleFieldsCancel()
          this.queryList()
        } else {
          this.$message.destroy()
          this.$message.error(res.message || '保存失败，请重试')
        }
      } catch (error) {
        this.$message.destroy()
        console.error('保存模板失败:', error)
        this.$message.error('保存模板失败')
      }
    },

    // 添加列
    addColumn() {
      const newField = {
        id: this.nextFieldId++,
        value: '',
        sort: this.templateFields.length + 1,
      }
      this.templateFields.push(newField)
      
      // 添加滚动到底部的功能
      this.$nextTick(() => {
        const tableBody = document.querySelector('.template-fields-table .ant-table-body')
        if (tableBody) {
          tableBody.scrollTop = tableBody.scrollHeight
        }
      })
    },

    // 删除选中的列
    deleteSelectedColumns() {
      if (!this.selectedColumns.length) {
        this.$message.warning('请选择要删除的列')
        return
      }

      this.templateFields = this.templateFields.filter((field) => !this.selectedColumns.includes(field.id))
      this.templateFields.forEach((field, index) => {
        field.sort = index + 1
      })
      this.selectedColumns = []
    },

    // 显示右键菜单
    showContextMenu(event, index) {
      this.contextMenuVisible = true
      this.currentColumnIndex = index
      this.contextMenuStyle = {
        position: 'fixed',
        top: `${event.clientY}px`,
        left: `${event.clientX}px`,
      }
      document.addEventListener('click', this.hideContextMenu)
    },

    // 隐藏右键菜单
    hideContextMenu() {
      this.contextMenuVisible = false
      document.removeEventListener('click', this.hideContextMenu)
    },

    // 插入列
    insertColumn(position) {
      const newField = {
        id: this.nextFieldId++,
        value: '',
        sort: 0,
      }
      const insertIndex = position === 'left' ? this.currentColumnIndex : this.currentColumnIndex + 1
      this.templateFields.splice(insertIndex, 0, newField)
      this.templateFields.forEach((field, index) => {
        field.sort = index + 1
      })
      this.hideContextMenu()
    },

    // 删除指定列
    deleteColumnByIndex(index) {
      this.templateFields.splice(index, 1)
      this.templateFields.forEach((field, i) => {
        field.sort = i + 1
      })
    },

    // 删除当前列
    deleteColumn() {
      if (this.currentColumnIndex >= 0 && this.currentColumnIndex < this.templateFields.length) {
        const deletedId = this.templateFields[this.currentColumnIndex].id
        this.deleteColumnByIndex(this.currentColumnIndex)
        this.selectedColumns = this.selectedColumns.filter((id) => id !== deletedId)
      }
      this.hideContextMenu()
    },

    // 处理字段编辑弹窗取消
    handleFieldsCancel() {
      this.templateFieldsVisible = false
      this.isView = false
      this.currentId = null
      this.templateFields = []
      this.selectedColumns = []
      this.formData = {
        templateName: '',
        templateType: 1,
      }
    },

    // 分页变化
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.queryList()
    },

  },
}
</script>
<style lang="less" scoped> 
.mag-tp {
  margin-top: 15px;
}
/deep/.ant-table-body {
  margin-top: 15px;
}
.fenye-top {
  margin-top: 15px;
}

.template-fields-container {
  position: relative;
  padding: 16px;
}

.template-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
  padding: 16px;
  background: #fafafa;
  border-radius: 4px;

  .template-info {
    width: 100%;

    h3 {
      margin: 0;
      color: #1890ff;
    }

    .template-type {
      margin: 8px 0 0;
      color: rgba(0, 0, 0, 0.65);
    }
    
    .template-name-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      
      .template-name-container {
        display: flex;
        align-items: center;
        
        span {
          margin-left: 8px;
        }
      }
    }
  }
  
  .template-fields-toolbar {
    display: flex;
    flex-wrap: wrap;
    
     
  }
}

.template-fields-table {
  max-height: 450px;
  overflow-y: auto;
  border: 1px solid #e8e8e8;
  border-radius: 4px;

  .fields-list-header {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    background: #fafafa;
    font-weight: 500;
    border-bottom: 1px solid #e8e8e8;

    .col-handle {
      width: 36px;
      flex-shrink: 0;
    }
    .col-checkbox {
      width: 40px;
      flex-shrink: 0;
    }
    .col-index {
      width: 60px;
      flex-shrink: 0;
      text-align: center;
    }
    .col-field {
      flex: 1;
      min-width: 0;
    }
  }

  .fields-draggable-list {
    .field-row {
      display: flex;
      align-items: center;
      padding: 8px 12px;
      border-bottom: 1px solid #f0f0f0;
      transition: background 0.2s;

      &:hover {
        background: #fafafa;
      }

      &:last-child {
        border-bottom: none;
      }
    }

    .col-handle {
      width: 36px;
      flex-shrink: 0;
      cursor: move;
      color: #1890ff;

      .anticon {
        font-size: 16px;
      }
    }
    .col-checkbox {
      width: 40px;
      flex-shrink: 0;
    }
    .col-index {
      width: 60px;
      flex-shrink: 0;
      text-align: center;
      color: rgba(0, 0, 0, 0.45);
    }
    .col-field {
      flex: 1;
      min-width: 0;

      .ant-select,
      .ant-input {
        width: 100%;
      }
    }

    .field-row-ghost {
      opacity: 0.5;
      background: #e6f7ff;
    }
  }
}

.context-menu {
  position: fixed;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  z-index: 1000;
  min-width: 160px;

  .ant-menu-item {
    padding: 8px 16px;

    .anticon {
      margin-right: 8px;
    }

    &[aria-disabled='true'] {
      color: rgba(0, 0, 0, 0.25);
      cursor: not-allowed;
    }
  }
}

/deep/ .ant-table-thead > tr > th {
  padding: 8px;
  height: 40px;
}

/deep/ .ant-table-tbody > tr > td {
  padding: 4px 8px;
  height: 36px;
}

/deep/ .ant-table-row {
  line-height: 1.2;
}

/deep/ .ant-form-item {
  margin-bottom: 0;
}

/deep/ .ant-form-item-control {
  line-height: 28px;
}

/deep/ .ant-select {
  line-height: 28px;
}
</style>
